module.exports = __webpack_public_path__ + "src/app/_content/imgs/discover/mot/motorrad-insurance.jpg?4e51ae5c89a6c5748bb8e46342a9d83b";